import React from "react";
import "../../css/Buttons/RectangleButtonStyles.css";
import { Colors } from "../../utils/colors";
import { Icon } from "@iconify/react";

type SelectItemRowProps = {
  title: string;
  description: string;
  selected: boolean;
  subComp?: React.ReactNode;
  subAlwaysComp?: React.ReactNode;
  disabled?: boolean;
  onPress: () => void;
};

const SelectItemRow = (props: SelectItemRowProps) => {
  const {
    title,
    description,
    selected,
    subComp,
    subAlwaysComp,
    disabled,
    onPress,
  } = props;

  return (
    <div className="ColumnNormal" style={{ gap: 20 }}>
      <div>
        <div
          className="AlignedRowSelect"
          style={{ gap: 14, pointerEvents: disabled ? "none" : "all" }}
          onClick={onPress}
        >
          <Icon
            icon={selected ? "mdi:radiobox-marked" : "mdi:radiobox-blank"}
            height={28}
            style={{
              color: Colors.BLACK,
              opacity: disabled ? 0.4 : 1,
              flexShrink: 0,
            }}
          />
          <div className="ColumnNormal" style={{ gap: 4 }}>
            <span
              className="bodyMedium"
              style={{ color: Colors.BLACK, opacity: disabled ? 0.4 : 1 }}
            >
              {title}
            </span>
            <span
              className="smallBodySubtext"
              style={{ opacity: disabled ? 0.4 : 1 }}
            >
              {description}
            </span>
          </div>
        </div>
        {subAlwaysComp ? (
          <div style={{ marginLeft: 42 }}>{subAlwaysComp}</div>
        ) : null}
      </div>
      {selected && subComp ? (
        <div style={{ marginLeft: 42 }}>{subComp}</div>
      ) : null}
    </div>
  );
};

export default SelectItemRow;
